import { PricingBoundariesDto } from '../../shared/dtos/pricing-boundaries.dto';

/**
 * Asset search boundaries DTO
 */
export class AssetSearchBoundariesDto {
	pricingBoundaries!: PricingBoundariesDto;
}
